/**
 * Lối Ngọc tile carvings (GPT art). Every symbol has its own hue and its
 * own silhouette, so two symbols can be told apart without colour.
 */
export interface JadeSymbol {
  readonly id: string;
  readonly name: string;
  readonly art: string;
  /** Glow colour when three of them join into a charm. */
  readonly tint: string;
}

export const JADE_SYMBOLS: readonly JadeSymbol[] = [
  { id: "rose", name: "Hoa hồng", art: "jade.sym-rose", tint: "#ff7a8a" },
  { id: "crown", name: "Vương miện", art: "jade.sym-crown", tint: "#ffd45a" },
  { id: "moon", name: "Trăng khuyết", art: "jade.sym-moon", tint: "#7fb2ff" },
  { id: "butterfly", name: "Bướm tím", art: "jade.sym-butterfly", tint: "#c896ff" },
  { id: "koi", name: "Cá chép", art: "jade.sym-koi", tint: "#ffa25a" },
  { id: "lotus", name: "Hoa sen", art: "jade.sym-lotus", tint: "#ffaccf" },
  { id: "clover", name: "Cỏ bốn lá", art: "jade.sym-clover", tint: "#6fdc8a" },
  { id: "key", name: "Chìa khóa", art: "jade.sym-key", tint: "#e0aa6a" },
];

export const JADE_SYMBOL_BY_ID: ReadonlyMap<string, JadeSymbol> = new Map(JADE_SYMBOLS.map((symbol) => [symbol.id, symbol]));

/** Art the Lối Ngọc scene needs besides the symbols. */
export const JADE_ASSET_IDS = [
  "jade.tile",
  "jade.tile-double",
  "jade.stone",
  "jade.gate",
  "jade.pocket",
  "jade.charm",
  "jade.socket",
  "jade.pin",
  "jade.lock",
  "jade.lock-open",
  "jade.mirror",
  "jade.tile-back",
  "jade.throne",
  "jade.ring",
  "lab.glow",
  "reward.sparkle",
] as const;
